module.exports = __webpack_public_path__ + "img/123.c0bc806f.svg";